<template>
  <section>
    <b-row >
      
      <b-col class="box-effect linear"
        >
            <b-card 
              >   
                <template v-slot:header >
                  <div class="header-card">
                    Informes De Aportes Pagados
                  </div> 
                </template> 
                <sw-tableget 
                    :tableItems="tableGBItems"
                    :tableSearch="tableGBSearch"
                    :tableOptions="tableGBoptions"
                    name="tableGetAportes"
                    route="get_aportesinformes"
                    :dataRoute="{inicial: fecha().fecha.minHoy, final: fecha().fecha.minHoy, others: []}"
                    @filtrar="getFiltrar"
                    @limpiar="getLimpiar"
                    @save="saveForm"
                    @pdf="getPdf"
                    @excell="getExcell"
                    >    
                    <template v-slot:filtrar>
                      <b-row style="margin-bottom:5px;padding:15px;background: rgba(0, 80, 166, 0.03);border: 1px ridge;">
                        <b-col :md="4">                          
                          <b-input-group class="filter-sw-group" size="sm" prepend="Desde:" style="margin-bottom:5px">
                            <input type="date" v-model="filter.inicial">
                          </b-input-group>   
                          <b-input-group class="filter-sw-group" size="sm" prepend="Hasta :" >
                            <input type="date" v-model="filter.final">
                          </b-input-group> 
                        </b-col>                         
                        <b-col :md="4">                          
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Razón">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_razon"                   
                              :options="filterSelects('datos_razon')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                          <b-input-group  class="filter-sw-group" size="sm" prepend="Centro">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_contacto"                   
                              :options="filterSelects('datos_contacto')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group> 
                        </b-col>
                         <b-col :md="4">
                         <b-input-group  class="filter-sw-group" size="sm" prepend="Asesor">
                            <c-multiselect
                              style="display:inline-block;flex: 1 1 0%"   
                              v-model="filter.id_datos_asesor"                   
                              :options="filterSelects('datos_asesor')"
                              label="name"
                              track-by="name"
                              :preselect-first="false"
                              :searchable="false"
                              placeholder="Seleccionar"
                              >
                              </c-multiselect>
                          </b-input-group>            
                          <b-form-checkbox style="margin-top:15px" v-model="filter.planilla" value="1">Solicita Planilla</b-form-checkbox>
                        </b-col>      
                      </b-row>                      
                    </template>   
                    <template v-slot:modal>
                        <sw-modalanularafiliacion 
                          v-if="openModal.modal.modal==='Anular'"
                          @save="saveForm">
                        </sw-modalanularafiliacion>
                        <sw-modalafiliacion 
                          v-if="openModal.modal.modal==='Registrar'"
                          @save="saveForm"                     
                          >
                        </sw-modalafiliacion> 
                    </template>   
                </sw-tableget>  
            </b-card>           
      </b-col>      
    </b-row>  
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex"
import indexMix    from './indexMix.js'
import storeMix    from './storeMix.js'
import tableMix    from './tableMix.js'
import saveMix     from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwModalanularafiliacion  from '@/components/modals/anularAfiliacion.vue'
import SwModalafiliacion  from '@/components/modals/afiliacion.vue'
import Multiselect from 'vue-multiselect'

export default {
  name: "afiliacion_informes",
  components: { 
    SwTableget,
    SwSearchs,
    'c-multiselect': Multiselect,
    SwModalanularafiliacion,
    SwModalafiliacion
  },
  mixins: [indexMix, storeMix, tableMix, saveMix, saveMixins,],
};
</script>
